import { ReactNode } from 'react'
import { chakra, Flex, Text } from '@chakra-ui/react'

import { formatTokenAmount } from '~/helpers'
import HelpTooltip from './HelpTooltip'

interface Props {
  label: string
  balance: number
  underlyingSymbol: string
  onBalanceClick?: () => void
  shouldShowBreakdownTooltip?: boolean
  tooltipLabel?: ReactNode
}

const FormBalanceText = ({
  label,
  balance,
  underlyingSymbol,
  onBalanceClick,
  shouldShowBreakdownTooltip = false,
  tooltipLabel,
}: Props) => {
  return (
    <Flex mt={2} justifyContent="flex-end">
      <Text
        textAlign="right"
        color="white"
        fontWeight="600"
        fontSize="xs"
        cursor={onBalanceClick ? 'pointer' : 'default'}
        onClick={onBalanceClick}
      >
        <chakra.span fontWeight="500" color="text.primary">
          {label}:{' '}
        </chakra.span>
        {formatTokenAmount(balance, underlyingSymbol)}
      </Text>
      {shouldShowBreakdownTooltip && <HelpTooltip variant="blurred" hasArrow={false} label={tooltipLabel} />}
    </Flex>
  )
}

export default FormBalanceText
